import { render, staticRenderFns } from "./sysselect.vue?vue&type=template&id=ffa63d60&scoped=true"
import script from "./sysselect.vue?vue&type=script&lang=js"
export * from "./sysselect.vue?vue&type=script&lang=js"
import style0 from "./sysselect.vue?vue&type=style&index=0&id=ffa63d60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa63d60",
  null
  
)

export default component.exports